import { PropsWithChildren, useRef, useState } from 'react';
import { HeaderContext, HeaderTitle, SubmitFunction, ValidationType } from './HeaderContext';

export const HeaderProvider = ({ children }: PropsWithChildren) => {
  const submitRef = useRef<SubmitFunction | null>(null);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [headerTitle, setHeaderTitle] = useState<HeaderTitle | undefined>(undefined);

  const setSubmit = (submit: SubmitFunction) => {
    submitRef.current = submit;
  };

  const triggerSubmit = (validationType: ValidationType) => {
    if (submitRef.current) {
      submitRef.current(validationType);
    }
  };

  return (
    <HeaderContext.Provider value={{ setSubmit, triggerSubmit, isFormLoading, setIsFormLoading, headerTitle, setHeaderTitle }}>
      {children}
    </HeaderContext.Provider>
  );
};
